import { Box, Paper, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { IStandardCardProps } from "./interface/interface";

export const StandardCard: React.FC<IStandardCardProps> = (props) => {
  const { heading, rightHeading, headingAlignment, sx, variant = "normal", fullHeight, subheading } = props;

  const isNode = React.isValidElement(rightHeading);
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";

  return (
    <Paper
      elevation={isLightMode ? 0 : 1}
      sx={{
        margin: 0,
        width: "100%",
        height: fullHeight ? "100%" : "auto",
        padding: variant === "normal" ? "10px" : "5px",
        backgroundColor: isLightMode ? "#fff" : theme.palette.background.paper,
        boxShadow: isLightMode
          ? "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px"
          : "rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px",
        ...sx,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems={headingAlignment || "center"}
        mb={heading ? 2 : 0}
      >
        {heading && (
          <>
            {typeof heading === "string" ? (
              <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
                <Typography variant="h2" fontWeight="700" sx={{ textAlign: "flex-start" }}>
                  {heading}
                </Typography>
                {subheading && (
                  <Typography variant="h4" fontWeight="400" sx={{ opacity: 0.7 }}>
                    {subheading}
                  </Typography>
                )}
              </Box>
            ) : heading}
          </>
        )}
        {isNode ? (
          <Box>{rightHeading}</Box>
        ) : (
          <Typography variant="body1" fontWeight="400">
            {rightHeading}
          </Typography>
        )}
      </Box>

      {/* {heading && <Divider sx={{ mt: 2, mb: 2 }} />} */}
      {props.children}
    </Paper>
  );
};
